import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserLocalTimeZoneDataParams {
  offset: number;
  timeZoneId: string;
  isUserSetTimeZone: boolean;
}

export class UpdateUserLocalTimeZoneDataRequest extends Request<IUpdateUserLocalTimeZoneDataParams, IResult> {
  constructor(params: IUpdateUserLocalTimeZoneDataParams) {
    super('updateUserLocalTimeZoneData', params);
  }
}
